/**
 * UI-тексты сервис-страницы туров (ToursPageContent).
 * Общие надзаголовки/якоря/теги берутся из servicePage (sp.*);
 * здесь — только вертикаль-специфичные строки. Динамические — функции.
 * Склонения страны (cCase) остаются в компоненте — сюда приходит готовое значение.
 */
export const toursPage = {
    en: {
        leaf: 'Tours',

        // Hero CTA
        heroBrowse: 'Browse destinations',
        heroPrices: 'Tours and prices',
        heroTypes: 'Tour types',

        // Anchor labels (vertical-specific; shared ones come from sp.anchor.*)
        anchorCities: 'Destinations',
        anchorTypes: 'Tour types',
        anchorPopular: 'Popular tours',
        anchorHow: 'How it works',

        // Destinations
        citiesEyebrow: 'Destinations',
        citiesTitle: (inCountry) => `Excursions${inCountry ? ` in ${inCountry}` : ''}`,
        cityTours: 'Tours',
        cityDetails: 'Details',

        // Providers
        providersTitle: 'Tour providers',

        // Tour types
        typesEyebrow: 'Tour types',
        typesTitle: 'What you can do',
        typeDetails: 'Details',

        // Popular tours (ledger)
        popularEyebrow: 'Popular tours',
        popularTitle: 'Popular tours and prices',
        popularLead: (hasFilter) => `Compare tours by length and price.${hasFilter ? ' Filter group or private tours.' : ''}`,

        // How it works
        howTitle: 'How it works',

        // Promo codes
        promosTitle: 'Tour promo codes',
        promoLead: 'Current discounts on tours and tickets — tap “Show code” to copy.',

        // Articles
        articlesTitle: 'Tour articles',
        articlesLead: 'The best excursions, routes and experiences — what to see and how to plan it.',

        // Bottom CTA
        ctaEyebrow: 'Experiences for every taste',
        ctaTitle: (to) => `Discover ${to || 'the country'} through tours.`,
        ctaBtn: 'Browse destinations →',
    },
    ru: {
        leaf: 'Туры',

        heroBrowse: 'Смотреть направления',
        heroPrices: 'Туры и цены',
        heroTypes: 'Типы туров',

        anchorCities: 'Направления',
        anchorTypes: 'Типы туров',
        anchorPopular: 'Популярные туры',
        anchorHow: 'Как это работает',

        citiesEyebrow: 'Направления',
        citiesTitle: (inCountry) => `Экскурсии${inCountry ? ' в ' + inCountry : ''}`,
        cityTours: 'Туры',
        cityDetails: 'Подробнее',

        providersTitle: 'Провайдеры туров',

        typesEyebrow: 'Типы туров',
        typesTitle: 'Что можно посмотреть',
        typeDetails: 'Подробнее',

        popularEyebrow: 'Популярные туры',
        popularTitle: 'Популярные туры и цены',
        popularLead: (hasFilter) => `Сравните туры по длительности и цене.${hasFilter ? ' Отфильтруйте групповые или индивидуальные.' : ''}`,

        howTitle: 'Как это работает',

        promosTitle: 'Промокоды на туры',
        promoLead: 'Актуальные скидки на экскурсии и билеты — нажмите «Показать код», чтобы скопировать.',

        articlesTitle: 'Статьи о турах',
        articlesLead: 'Лучшие экскурсии, маршруты и впечатления — что посмотреть и как организовать.',

        ctaEyebrow: 'Впечатления на любой вкус',
        ctaTitle: (to) => `Откройте${to ? ' ' + to : ' страну'} через экскурсии.`,
        ctaBtn: 'Смотреть направления →',
    },
};
